import { DateTime } from "luxon";
import { Typography } from "@mui/material";
import type { Student } from "../../providers/studentsProvider";
import { getPracticalExamEligibilityDate, getTheoryExamEligibilityDate } from "../../model/examEligibility";
import { formatDate } from "../../utils/calendar";
import { useGetList, useRecordContext } from "react-admin";
import { Column } from "../../misc/Column";
import { PracticalExam, TheoryExam } from "../../model/autovioCalendarEvents";

export function ExamEligibilityInfo() {
  const student = useRecordContext<Student>();
  const theoryExamEligibility = formatExamEligibility(
    getTheoryExamEligibilityDate(student, student.activeOrMostRecentBookedTraining.drivingLicenseClass),
  );
  const practicalExamEligibility = formatExamEligibility(
    getPracticalExamEligibilityDate(student, student.activeOrMostRecentBookedTraining.drivingLicenseClass),
  );
  const { data: exams = [] } = useGetList<TheoryExam | PracticalExam>("calendarEvents", {
    filter: {
      studentId: student.id,
      drivingSchoolId: student.drivingSchoolId,
      type: ["TheoryExam", "PracticalExam"],
    },
    pagination: { page: 1, perPage: 100 },
  });
  const hasPreviousPracticalExam = exams.some((exam) => exam.drivingLessonType === "praktischePruefung");
  const hasPreviousTheoryExam = exams.some((exam) => exam.type === "TheoryExam");
  if (!theoryExamEligibility && !practicalExamEligibility) {
    return null;
  }
  return (
    <Column sx={{ mt: 0.5, gap: 0.5 }}>
      {theoryExamEligibility && (
        <Typography variant="body2" color="textSecondary">
          {`${hasPreviousTheoryExam ? "Nächste " : ""}Theorieprüfung frühestens ablegbar ab: `}
          <b>{theoryExamEligibility}</b>
        </Typography>
      )}
      {practicalExamEligibility && (
        <Typography variant="body2" color="textSecondary">
          {`${hasPreviousPracticalExam ? "Nächste " : ""}Praktische Prüfung frühestens ablegbar ab: `}
          <b>{practicalExamEligibility}</b>
        </Typography>
      )}
    </Column>
  );
}

function formatExamEligibility(date: DateTime | null): string | null {
  if (!date) {
    return null;
  }
  const today = DateTime.now().setZone("Europe/Berlin").startOf("day");
  return date <= today ? "sofort" : formatDate(date);
}
